export default __webpack_public_path__ + "static/media/alwaysOn.1c6b3803.svg";